import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"

import pixel from "@frog/source/views/app/stage/utility/pixel.js"
import * as Objdict from "objdict"
import Geometry from "@frog/source/utility/Geometry.js"
import skills from "@frog/source/data/skills.js"
import World from "@frog/source/models/World.js"

import Colors from "@frog/source/data/colors.js"
// const Colors = {
//     "yellow": "#fed429",
//     "red": "#EC4E20",
//     "green": "#33CA7F",
//     "black": "#2E382E",
//     "blue": "#2589BD",
//     "white": "#FFFFFF",
// }

const RANGE_IMAGES = {
    "block": {
        // "invoke skill": require("@frog/source/assets/images/red.range.png"),
        // "move": require("@frog/source/assets/images/blue.range.png"),

        // "invoke skill": require("@frog/source/assets/images/ld47/invoke skill range.png"),
        // "move": require("@frog/source/assets/images/ld47/move range.png"),

        // "invoke skill": {
        //     "a": require("@frog/source/assets/images/bomber-tactics/shout-tileset/range-invoke-skill-a.png"),
        //     "b": require("@frog/source/assets/images/bomber-tactics/shout-tileset/range-invoke-skill-b.png"),
        // },
        // "move": {
        //     "a": require("@frog/source/assets/images/bomber-tactics/shout-tileset/range-move-a.png"),
        //     "b": require("@frog/source/assets/images/bomber-tactics/shout-tileset/range-move-b.png"),
        // },

        // "invoke skill": {
        //     "a": require("@frog/source/assets/images/bomber-tactics/range-invoke-skill-a.png"),
        //     "b": require("@frog/source/assets/images/bomber-tactics/range-invoke-skill-b.png"),
        // },
        // "move": {
        //     "a": require("@frog/source/assets/images/bomber-tactics/range-move-a.png"),
        //     "b": require("@frog/source/assets/images/bomber-tactics/range-move-b.png"),
        // },

        // "invoke skill": require("@frog/source/assets/images/cryptid-tactics/range-invoke-skill.png"),
        // "invoke skill support": require("@frog/source/assets/images/cryptid-tactics/range-invoke-skill-support.png"),
        // "move": {
        //     "a": require("@frog/source/assets/images/cryptid-tactics/range-move-a.png"),
        //     "b": require("@frog/source/assets/images/cryptid-tactics/range-move-b.png"),
        // },
    },
    // "east-ramp": {
    //     "invoke skill": require("@frog/source/assets/images/cryptid-tactics/range-invoke-skill-east-ramp.png"),
    //     "invoke skill support": require("@frog/source/assets/images/cryptid-tactics/range-invoke-skill-support-east-ramp.png"),
    //     "move": {
    //         "a": require("@frog/source/assets/images/cryptid-tactics/range-move-east-ramp-a.png"),
    //         "b": require("@frog/source/assets/images/cryptid-tactics/range-move-east-ramp-b.png"),
    //     },
    // },
    // "south-ramp": {
    //     "invoke skill": require("@frog/source/assets/images/cryptid-tactics/range-invoke-skill-south-ramp.png"),
    //     "invoke skill support": require("@frog/source/assets/images/cryptid-tactics/range-invoke-skill-support-south-ramp.png"),
    //     "move": {
    //         "a": require("@frog/source/assets/images/cryptid-tactics/range-move-south-ramp-a.png"),
    //         "b": require("@frog/source/assets/images/cryptid-tactics/range-move-south-ramp-b.png"),
    //     },
    // }
}

Objdict.forEach(RANGE_IMAGES, (images) => {
    images["move through"] = images["move"]
    images["wait-for-move"] = images["move"]
})


// // This logic is very similiar to Selection.findAction, but takes
// // some performance shortcuts for the rendering loop.
// function findAction(actionlist, unit) {
//     // if(App.game.encounter.selection.selectedSkillKey != undefined) {
//     // || unit.energy["move"] == false) {
//     if(unit.energy["move"] == false
//     && unit.energy["invoke skill"] == true) {
//         return actionlist.find((action) => {
//             return action.type == "invoke skill"
//                 && Geometry.equals(action.positions[1], unit.position)
//         })
//     } else if(unit.energy["move"] == true) {
//         return actionlist.find((action) => {
//             return action.type == "move"
//                 || action.type == "wait-for-move"
//                 || action.type == "move through"
//         }) || actionlist.find((action) => {
//             return action.type == "invoke skill"
//         })
//         // return actionlist.find((action) => action.type == "move") || actionlist[0]
//     }
// }
//
// // TODO: merge this in with the range function so it's not duped
// export function getActionableTileType(position, stage) {
//     const unitKey = App.game.encounter.selection.selectedUnitKey || App.game.encounter.selection.hoveredUnitKey
//     if(unitKey != undefined
//     && Director.isPerforming != true) {
//         const unit = stage.units[unitKey]
//         let actionmap = unit.actionmap
//         if(stage.nextTurn != undefined
//         && stage.nextTurn.aiActions != undefined
//         && stage.nextTurn.aiActions[unit.key] != undefined
//         && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
//             actionmap = stage.nextTurn.aiActions[unit.key].actionmap
//         }
//         if(unit.affiliation == "bad") {
//             console.log(actionmap)
//         }
//         if(unit == undefined
//         || actionmap == undefined) {
//             return
//         }
//         const actionlist = actionmap[Geometry.toString(position)]
//         if(actionlist == undefined) return
//         const action = findAction(actionlist, unit)
//         if(action == undefined) return
//         const terrain = World.getTerrain(stage.world, action.position)
//         // if(terrain.position.z == 0) return
//         return action.type
//     }
// }

const ROTATIONS = {}
const MAX_ROTATION = 10
for(let x = 0; x < 6; x += 1) {
    for(let y = 0; y < 6; y += 1) {
        ROTATIONS[x + "x" + y] = (Math.random() * MAX_ROTATION) - (MAX_ROTATION / 2)
    }
}

const RANGE_COLORS = {
    "move": Colors.blue,
    "invoke skill": Colors.red,
    "invoke skill support": Colors.red,
}

export default function ActionRangeLayer(stage) {
    if(Director.isPerforming == true) return

    return [
        ActionRange(stage)
    ]
}

function ActionRange(stage) {
    const views = []
    if((App.game.encounter.selection.activeUnitKey != undefined
    && App.game.encounter.selection.activeUnit.affiliation == "good")
    || (App.game.encounter.selection.selectedUnitKey != undefined
    && App.game.encounter.selection.selectedUnit.affiliation == "bad")) {
        const unit = stage.units[App.game.encounter.selection.selectedUnitKey || App.game.encounter.selection.activeUnitKey]
        if(unit == undefined) return
        if(unit.isDead == true) return
        let actionmap = unit.actionmap
        if(stage.nextTurn != undefined
        && stage.nextTurn.aiActions != undefined
        && stage.nextTurn.aiActions[unit.key] != undefined
        && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
            actionmap = stage.nextTurn.aiActions[unit.key].actionmap
        }
        if(actionmap == undefined) return
        Objdict.forEach(actionmap, (actionlist, positionKey) => {
            let action = undefined
            if(App.game.encounter.selection.mode(unit) == "move only") {
                action = actionlist.find((action) => {
                    return action.type == "move"
                        || action.type == "wait-for-move"
                        || action.type == "move through"
                })
                // || actionlist.find((action) => {
                //     return action.type == "invoke skill"
                // })
            } else if(App.game.encounter.selection.mode(unit) == "invoke skill only") {
                action = actionlist.find((action) => {
                    return action.type == "invoke skill"
                        && action.skillKey == (App.game.encounter.selection.selectedSkillKey || unit.skills[0])
                        && Geometry.equals(action.positions[1], unit.position)
                })
            }
            if(action == undefined) return
            const terrain = World.getTerrain(stage.world, action.position)
            if(terrain == undefined) return
            let type = action.type
            if(action.skillKey != undefined
            && skills.get(action.skillKey) != undefined
            && skills.get(action.skillKey).isSupport == true) {
                type = "invoke skill support"
            }
            // let image = RANGE_IMAGES[terrain.shape || "block"][type]
            // if(image.a != undefined && image.b != undefined) {
            //     image = image[terrain.position.x % 2 ? "a" : "b"]
            // }
            views.push({
                "key": "unit/" + unit.key + "/range/" + positionKey,
                "type": "rectangle",
                "width": 8,
                "height": 8,
                // "opacity": 0.5,
                "color": RANGE_COLORS[action.type] || RANGE_COLORS["move"],
                "position": pixel("range", {
                    "x": terrain.position.x,
                    "y": terrain.position.y,
                    "z": terrain.position.z + terrain.size.z,
                }),
            })
        })
    }
    return views
}
